import { render, staticRenderFns } from "./accordion-block.vue?vue&type=template&id=7f58999a&scoped=true"
import script from "./accordion-block.vue?vue&type=script&lang=js"
export * from "./accordion-block.vue?vue&type=script&lang=js"
import style0 from "./accordion-block.vue?vue&type=style&index=0&id=7f58999a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f58999a",
  null
  
)

export default component.exports